import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Skeleton de carga de la sección de perfil.
 * Refleja el layout final: avatar + campos + subsecciones.
 */
export function ProfileSkeleton() {
  return (
    <div className="space-y-8" data-testid="settings-profile-skeleton">
      {/* Header */}
      <div className="space-y-1.5">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-64" />
      </div>

      {/* User data form */}
      <div className="space-y-5">
        <Skeleton className="h-5 w-36" />
        {/* Avatar */}
        <div className="flex flex-col items-center gap-3 md:flex-row md:items-end">
          <Skeleton className="size-20 rounded-full shrink-0" />
          <div className="flex flex-col gap-2 w-full md:w-auto">
            <Skeleton className="h-8 w-28" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>
        {/* Fields */}
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Subsections */}
      <div className="space-y-6">
        <Skeleton className="h-px w-full" />
        <Skeleton className="h-5 w-24" />
        <div className="grid grid-cols-3 gap-3">
          <Skeleton className="h-20 rounded-lg" />
          <Skeleton className="h-20 rounded-lg" />
          <Skeleton className="h-20 rounded-lg" />
        </div>
        <Skeleton className="h-px w-full" />
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-10 rounded-lg" />
        <Skeleton className="h-10 rounded-lg" />
      </div>
    </div>
  );
}
